import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Rect,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(
          Path,
          {
            d: "M10 20H4a2 2 0 0 1-2-2V5c0-1.1.9-2 2-2h3.93a2 2 0 0 1 1.66.9l.82 1.2a2 2 0 0 0 1.66.9H20a2 2 0 0 1 2 2v2.5",
            stroke: `${color}`
          }
        ),
        /* @__PURE__ */ jsx(Rect, { width: "8", height: "5", x: "14", y: "17", rx: "1", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M20 17v-2a2 2 0 1 0-4 0v2", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "FolderLock";
const FolderLock = memo(themed(Icon));
export {
  FolderLock
};
//# sourceMappingURL=folder-lock.js.map
